<template>
  <div class="wrapper d-flex flex-column min-vh-100 bg-body">
    <guest-header />
    <main v-show="!pageLoadingStatus" class="container-fluid py-3">
      <router-view />
    </main>
  </div>
</template>

<script>
import GuestHeader from "@/views/organisms/GuestHeader";

export default {
  name: 'GuestLayout',
  components: {
    GuestHeader,
  },
  computed: {
    pageLoadingStatus() {
      return this.$store.state.pageLoading;
    },
  },
}
</script>
